import React from "react";
import { DotLoader } from "../../_components";
import "./style.scss";

export const Button = ({
  size = "medium",
  variant = "primary",
  className,
  colorType = "info",
  children,
  onClick,
  disabled = false,
  isLoading = false,
  type = "button",
}) => {
  return (
    <button
      className={`button_container ${size} ${variant} ${colorType} ${
        disabled && "disabled"
      } ${className || ""}`}
      disabled={isLoading || disabled}
      onClick={() => (isLoading ? {} : onClick?.())}
      type={type}
    >
      {isLoading ? <DotLoader /> : children}
    </button>
  );
};
